import { Injectable, inject } from '@angular/core';
import { DataFilterAction } from '@shared/constants/data-filter-action';
import { DialogService } from '@core/services/dialog.service';
import { FilterWithSelectionCrudDialogComponent } from './filter-with-selection-crud-dialog.component';
import { FilterWithSelectionCrudDialogData } from './interfaces';
import { DvDialogComponent } from '@devinco/ui/dds';

@Injectable({ providedIn: 'root' })
export class FilterCrudDialogService {
  private dialog = inject(DialogService);

  openFilterCrudDialog<T>(
    data: FilterWithSelectionCrudDialogData,
    extraData?: T
  ): DvDialogComponent<
    FilterWithSelectionCrudDialogData,
    FilterWithSelectionCrudDialogComponent
  > {
    return this.dialog.open({
      size: 'sm',
      title: this.getFleetCrudModalTitleKey(data.dataFilterAction),
      confirmText: 'General.Save',
      cancelText: 'General.Cancel',
      hideFooter: true,
      contentComponent: FilterWithSelectionCrudDialogComponent,
      data: {
        ...data,
        extraData,
      } as FilterWithSelectionCrudDialogData,
    });
  }

  getFleetCrudModalTitleKey(dataFilterAction: DataFilterAction): string {
    switch (dataFilterAction) {
      case DataFilterAction.Add:
        return 'Fleet.AddDialog.Title';
      case DataFilterAction.Copy:
        return 'Fleet.FilterCopyDialog.Title';
      case DataFilterAction.Update:
        return 'Fleet.UpdateDialog.Title';
      default:
        return '';
    }
  }
}
